import { Component, OnDestroy, OnInit } from '@angular/core';

import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { HelperService, HTTPService } from 'app/services';

@Component({
  selector: 'app-parts-ordering-remove-item',
  templateUrl: './parts-ordering-remove-item-dialog.component.html',
  styleUrls: ['./parts-ordering-remove-item-dialog.component.scss'],
  providers: [DialogService],
})
export class PartsOrderingRemoveItemDialogComponent implements OnInit, OnDestroy {
  items: any[] = [];
  source: string = '';
  orderId: string = '';
  isProcessing: boolean = false;

  constructor(private dynamicDialogConfig: DynamicDialogConfig, private dynamicDialogRef: DynamicDialogRef, private httpService: HTTPService, private helperService: HelperService) {}

  ngOnInit() {
    const { orderId, source, items } = this.dynamicDialogConfig.data;

    this.orderId = orderId;
    this.items = items;
    this.source = source;
  }

  ngOnDestroy(): void {}

  handleClose(isSuccess: boolean = false, data: any = {}) {
    this.dynamicDialogRef.close({ isSuccess, data });
  }

  handleChange(item: string, type: string, isChecked: any) {
    item[type] = isChecked;

    if (type === 'removeFromCart') {
      item['removeFromServiceLine'] = true;
    }
  }

  async onRemoveItem() {
    this.isProcessing = true;

    try {
      const promises = [];
      this.items.forEach(async (item) => {
        if (item.removeFromCart) {
          if (item.itemSource === 'PartsTech') {
            promises.push(this.httpService.deletePartsTechItem(this.orderId, this.items));
          } else if (item.itemSource === 'TireHub') {
            promises.push(this.httpService.deleteTireHubItem(this.orderId, this.items));
          } else if (item.itemSource === 'TireConnect') {
            promises.push(this.httpService.deleteTireConnectItem(this.orderId, this.items));
          } else if (item.itemSource === 'RepairLink') {
            promises.push(this.httpService.deleteRepairLinkItem(this.orderId, this.items));
          }
        }
      });

      await Promise.all(promises);

      this.handleClose(true, this.items);
    } catch (err) {
      this.helperService.showToaster('error', err);
    } finally {
      this.isProcessing = false;
    }
  }
}
